import { render } from "./sub-menu.vue?vue&type=template&id=8095147a&ts=true"
import script from "./sub-menu.vue?vue&type=script&lang=ts"
export * from "./sub-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__